import React, { useEffect, useRef, useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import "../Style/VendorFilter.css";

const DatalistInput = ({
  label,
  name,
  value,
  listId,
  options,
  onChange,
  showList,
  displayKey = "label",
  inputRef,
  onKeyDown,
}) => {
  return (
    <Form.Group as={Col} xs={6} sm={4} md={3} lg={2} controlId={name}>
      <div className="dropdown-label">{label}</div>
      <Form.Control
        type="text"
        list={showList ? listId : undefined}
        value={value}
        placeholder={` ${label}`}
        onChange={(e) => onChange(name, e.target.value)}
        onKeyDown={onKeyDown}
        ref={inputRef}
        autoComplete="off"
      />
      {showList && (
        <datalist id={listId}>
          {options.map((opt, index) => (
            <option key={index} value={opt[displayKey]}>
              {opt.label}
            </option>
          ))}
        </datalist>
      )}
    </Form.Group>
  );
};

const VendorAdvanceFilter = ({
  filters,
  vendors,
  onFilterChange,
  fetchAdvanceByVendorId,
  onReset,
}) => {
  const [localFilters, setLocalFilters] = useState(filters);
  const [showDropdown, setShowDropdown] = useState({
    vendor_id: false,
    status: false,
  });
  const vendorRef = useRef(null);
  const statusRef = useRef(null);
  const resetRef = useRef(null);



  useEffect(() => {
    setLocalFilters(filters);
  }, [filters]);

  const handleInputChange = (name, value) => {
    setLocalFilters((prev) => ({ ...prev, [name]: value }));
    onFilterChange(name, value);

    setShowDropdown((prev) => ({
      ...prev,
      [name]: String(value || "").trim().length > 0,
    }));
  };

  const handleVendorChange = (name, value) => {
    const vendor = vendors.find(
      (v) => v.name.toLowerCase() === value.toLowerCase()
    );

    if (vendor) {
      setLocalFilters((prev) => ({ ...prev, vendor_id: vendor.id }));
      onFilterChange("vendor_id", vendor.id);
      // fetchAdvanceByVendorId(vendor.id);
    } else {
      handleInputChange("vendor_id", value);
    }
  };

  const statusOptions = [
    { value: "open", label: "Open" },
    { value: "closed", label: "Closed" },
  ];

  const handleKeyDown = (e, nextRef) => {
    if (e.key === "Enter") {
      e.preventDefault();
      nextRef?.current?.focus();
    }
  }

  return (
    <Form className="vendor-advance-filter-form">
      <Row className="g-2 align-items-end">
        <DatalistInput
          label="Vendor"
          name="vendor_id"
          value={
            vendors.find((v) => v.id === localFilters.vendor_id)?.name ||
            localFilters.vendor_id
          }
          listId="vendorList"
          options={vendors.map((v) => ({ value: v.id, label: v.name }))}
          onChange={handleVendorChange}
          showList={showDropdown.vendor_id}
          inputRef={vendorRef}
          onKeyDown={(e)=>handleKeyDown(e,statusRef)}
        />

        <DatalistInput
          label="Status"
          name="status"
          value={localFilters.status}
          listId="statusList"
          options={statusOptions}
          onChange={handleInputChange}
          showList={showDropdown.status}
          inputRef={statusRef}
          onKeyDown={(e)=>handleKeyDown(e,resetRef)}
        />

        <Col className="d-flex justify-content-end align-items-center">
          <Button variant="secondary" onClick={onReset}
          ref={resetRef}>
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
};

export default VendorAdvanceFilter;
